import { Box, IconButton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  NotificationsArrowLeftIcon,
  NotificationCloseIcon,
} from '~/shared/components/Icons/Icons';
import {
  NotificationIconType,
  NotificationUrgency,
} from '~/pages/layout/components/NotificationDrawer/types';
import { NotificationDetailsLabel } from './NotificationDetailsLabel';
import { NotificationCardHeader } from './NotificationCardHeader';
import { notificationStyles } from '~/shared/theme/theme';

interface NotificationDetailsProps {
  title: string;
  deviceTitle: string;
  roomTitle: string;
  alertDescription: string;
  stepsToPerform: string;
  type: NotificationIconType;
  typeLabel: string;
  date: string;
  resolvedDate?: string;
  urgency: NotificationUrgency;
  isResolved: boolean;
  onBack: () => void;
  onClose: () => void;
}

export function NotificationDetails({
  title,
  deviceTitle,
  roomTitle,
  alertDescription,
  stepsToPerform,
  date,
  resolvedDate,
  urgency,
  isResolved,
  onBack,
  onClose,
  type,
  typeLabel,
}: NotificationDetailsProps) {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          backgroundColor: 'background.paper',
          p: 6,
          py: 5,
          borderBottom: '1px solid #E5E5E5',
        }}
      >
        <Stack direction="row" alignItems="center" spacing={3}>
          <IconButton onClick={onBack}>
            <NotificationsArrowLeftIcon
              fontSize="small"
              sx={{ color: 'primary.main' }}
            />
          </IconButton>
          <Typography
            variant="h6"
            fontWeight={600}
            sx={{ color: notificationStyles.lightText }}
          >
            {t('notificationDetails.title')}
          </Typography>
        </Stack>
        <IconButton onClick={onClose}>
          <NotificationCloseIcon
            fontSize="small"
            sx={{ color: 'primary.main' }}
          />
        </IconButton>
      </Box>
      <Box sx={{ p: 6 }}>
        <NotificationCardHeader
          type={type}
          title={title}
          alertDescription={alertDescription}
          typeLabel={typeLabel}
          date={date}
          resolvedDate={resolvedDate}
          isResolved={isResolved}
        />

        <NotificationDetailsLabel
          label={t('notificationDetails.sourceCcu')}
          value={deviceTitle}
        />
        <NotificationDetailsLabel
          label={t('notificationDetails.room')}
          value={roomTitle}
        />
        <NotificationDetailsLabel
          label={t('notificationDetails.urgency')}
          value={
            {
              high: t('notificationDetails.urgencyLabel.high'),
              mid: t('notificationDetails.urgencyLabel.mid'),
              none: t('notificationDetails.urgencyLabel.low'),
            }[urgency]
          }
        />
        <NotificationDetailsLabel
          label={t('notificationDetails.stepsToPerform')}
          value={stepsToPerform}
          column
        />
      </Box>
    </Box>
  );
}
